
var __build_tag: string = null;

export function build_num(): string {
    if (!__build_tag) {
        if (location) {
            if (location.pathname) {
                let tokens: string[] = location.pathname.split('/')
                if (tokens[3]) {
                    __build_tag = tokens[3]
                }
                else {
                    console.error(`build_num cannot be determined from pathname ${location.pathname}`);
                    __build_tag = `localhost_build`;
                }
            }
        }
    }
    return __build_tag;
}


// WEBPACK FOOTER //
// ./src/ts/Version.ts